

















import EventBus from '@/eventBus';
import axios from 'axios';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoSelect from '../co-select/CoSelect.vue';

export default {
    name: 'CoManagePaymentMethodsInCheckout',
    components: {
        CoSelect,
        CoLink,
    },
    data() {
        return {
            methodsLoading: false,
            paymentMethods: [] as object[],
            activeMethodValue: null as object | null,
        };
    },
    created() {
        this.getPaymentMethods();
        // make sure payment methods are refreshed when user returns to this window
        document.addEventListener('visibilitychange', this.documentFocusHandler);
    },
    beforeDestroy() {
        // remove event listener for visibility change
        document.removeEventListener('visibilitychange', this.documentFocusHandler);
    },
    computed: {
        paymentOptions() {
            return this.paymentMethods.map((method) => {
                let option;
                if (method.Type === 'card') {
                    option = {
                        Name: `${method.Details?.CardBrand} **** ${method.Details?.Last4Digits} (${method.Details?.ExpMonth}/${method.Details?.ExpYear})`,
                        Value: method.ID,
                    };
                } else {
                    option = {
                        Name: `SEPA ${method.Details?.Country}**${method.Details?.BankCode}**** (${this.$t('datetime', {
                            date: method.Created,
                            customFormat: 'MM/yy',
                        })})`,
                        Value: method.ID,
                    };
                }
                return option;
            });
        },
    },
    methods: {
        getPaymentMethods() {
            this.methodsLoading = true;
            axios({
                method: 'GET',
                url: '/user/account/billing/payment-methods',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.paymentMethods = response?.data || [];
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.setActiveMethodValue();
                    this.methodsLoading = false;
                });
        },
        selectedPaymentMethod(method) {
            if (!method?.Value || method?.Value === this.activeMethodValue?.Value) {
                return;
            }
            this.setAsDefault(method.Value);
        },
        setAsDefault(paymentMethodId) {
            this.methodsLoading = true;
            const data = {
                ID: paymentMethodId,
            };
            axios({
                method: 'PUT',
                url: '/user/account/billing/payment-methods/default',
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    });
                })
                .catch((error) => {
                    console.error(error);
                    EventBus.$emit('ERROR', {
                        Message: 'Failed to set this method as standard',
                        Details: '',
                    });
                    console.log(error);
                })
                .finally(() => {
                    this.getPaymentMethods();
                });
        },
        setActiveMethodValue() {
            const item = this.paymentMethods.find((i) => i.Default === true);
            this.activeMethodValue = item ? { Value: item.ID } : null;
        },
        documentFocusHandler() {
            if (document.visibilityState === 'visible') {
                this.getPaymentMethods();
            }
        },
    },
};
